import React from 'react'

const ListIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <rect width="48" height="48" rx="12" fill="#F0FDF4" />
    <circle cx="24" cy="24" r="8" fill="#24D164" />
  </svg>
)

export default ListIcon
